export default __webpack_public_path__ + "images/H3.0f27d94.png";